import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  evaluatorModalContainer: {
    width: "40%",
    padding: "2rem 3rem",
    backgroundColor: "#fff",
    borderRadius: "6px",
    [emulatorScreen(theme)]: {
      padding: "1rem 2.5rem",
    },
    [mobileScreen(theme)]: {
      padding: "1rem 1.5rem",
      // width: "240px",
    },
  },

  comparisonContainer: {
    padding: 30,
    [emulatorScreen(theme)]: {
      padding: 10,
    },
    [mobileScreen(theme)]: {
      padding: 10,
      // width: "240px",
    },
  },

  comparisonFirstHalf: {
    backgroundColor: "#ececec",
    flex: 2,
    justifyContent: "space-evenly",
    padding: "5px  0px",
    alignItems: "center",
    [emulatorScreen(theme)]: {
      padding: 0,
    },
    [mobileScreen(theme)]: {
      padding: 0,
    },
  },
  adjustImage: {
    width: "20%",
  },
  newPriceBox: {
    marginTop: 24,
    [mobileScreen(theme)]: {
      marginTop: 5,
    },
  },
  whiteSpace: {
    backgroundColor: "#fff",
    flex: 0.2,
  },
  comparisonSecondHalf: {
    backgroundColor: "#ececec",
    flex: 0.8,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  evalDesc: {
    fontSize: 15,
    margin: "24px 0",
    color: "#003e4c",
    fontFamily: "Rubik",
    [emulatorScreen(theme)]: {
      margin: "8px 0",
      fontSize: 12,
    },
    [mobileScreen(theme)]: {
      margin: "7px 0",
      fontSize: 9,
    },
  },

  equationImg: {
    maxWidth: "57%",
    height: 45,
    [mobileScreen(theme)]: {
      maxWidth: "50%",
      height: 35,
    },
  },

  correctIncorrectIcon: {
    width: "200px",
    height: "45px",
    [emulatorScreen(theme)]: {
      width: "120px",
      height: "30px",
    },
    [mobileScreen(theme)]: {
      width: "120px",
      height: "30px",
    },
  },
  yearPrice: {
    color: "#003E4C",
    fontWeight: "400",
    paddingTop: "10px 0px",
    fontSize: 22,
    fontFamily: "'Oswald',sans-serif",
    textAlign: "center",
    [emulatorScreen(theme)]: {
      fontSize: 14,
    },
    [mobileScreen(theme)]: {
      fontSize: 10,
    },
  },

  cheaperText: {
    color: "#538918",
    fontWeight: "400",
    paddingTop: "10px 0px",
    fontSize: 17,
    marginBottom: 10,
    fontFamily: "'Oswald',sans-serif",
    textAlign: "center",
    [emulatorScreen(theme)]: {
      fontSize: 13,
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
    },
  },

  submitButton: {
    backgroundColor: "#00b1d9",
    color: "#fff",
    fontSize: "30px",
    fontWeight: "500",
    padding: "0px 20px",
    borderRadius: "5px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [emulatorScreen(theme)]: {
      padding: "0px 10px",
      fontSize: 22,
    },
    [mobileScreen(theme)]: {
      fontSize: "18px",
      padding: "0px 10px",
    },
  },
  bottomDescription: {
    margin: "24px 0",
    fontFamily: "Rubik",
    color: "#898989",
    fontSize: 14,
    padding: "0px 30px",
    [emulatorScreen(theme)]: {
      margin: "10px 0",
      fontSize: 11,
    },
    [mobileScreen(theme)]: {
      margin: "6px 0",
      fontSize: 8,
    },
  },
});

export default styles;
